import { render, staticRenderFns } from "./knowledge-list.vue?vue&type=template&id=3003e925&"
import script from "./knowledge-list.vue?vue&type=script&lang=js&"
export * from "./knowledge-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports